import { ProfileContainer } from './views/user/ProfileContainer'
export default ProfileContainer

